<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->   
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- <Banner :banner="bannerList"  @click="loseFocus()"></Banner> -->
    <div class="img_box">
        <div class="pc_img">
        <img alt="" src="static/picture/1-200z91406063f.jpg" /><img alt="" src="static/picture/1-200z914061c23.jpg" /></div>
    <div class="wap_img">
        <img alt="" src="static/picture/1-200z9140632112.jpg" /><img alt="" src="static/picture/1-200z9140644460.jpg" /> <img alt="" src="static/picture/1-200z9140f0e0.jpg" /><img alt="" src="static/picture/1-200z9140g2444.jpg" /></div>

    </div>
    <hr class="hr_1 mt0 mb30">
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/luara_banner1.jpg'},
        {url:'static/picture/luara_banner2.jpg'},
        {url:'static/picture/luara_banner3.jpg'},
      ],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.judgeLogin();
  },
  methods: {
    
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------brand.html  start----------------*/
.img_box{
	width: 100%;
	overflow: hidden;
	margin: 0 auto;
}
.img_box img{
	max-width: 100%;
	margin: 0 auto;
	display: block;
}
.img_box .video_box{
	width: 100%;
	margin: 0 auto;
	position: relative;
}
.img_box .video_box .zhezhao{
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0px;
	top: 0px;
	z-index: 555;
	overflow: hidden;
	cursor: pointer;
}
.img_box .video_box .zhezhao img{
	width: 100%;
	height: 100%;
	transition:all 1s ease-in-out;
}
.img_box .video_box .zhezhao img.img_pc{
	display: block;
}
.img_box .video_box .zhezhao img.img_wap{
	display: none;
}
.img_box .video_box video{
	width: 100%;
}
/*------------brand.html  end----------------*/
</style>


// WEBPACK FOOTER //
// src/view/Html/NEW_ARRIVIAL.vue